// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3icRx","description":"_3Ew7n","bottomBorder":"_2TYTW"};